/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-undef */
import React, { useEffect, useState } from 'react';
import MetaTags from 'react-meta-tags';
import { useDispatch, useSelector } from 'react-redux';
import './Dashboard.scss';

import { DashBreadcrumb } from '../../../components/Common/Breadcrumb';
import {
  fetchDashboardGraphdata,
  fetchDashboardSummerydata,
  fetchStatausCount,
} from '../../../common/data/action/dashboardaction';
import { allOrderStatusCount } from '../actions/orderActions';
import Spinearea from '../../AllCharts/apex/SplineArea';
import RevenueSplineArea from '../../AllCharts/apex/RevenueSplineArea';
import AovSplineArea from '../../AllCharts/apex/AovSplineArea';
import 'react-datepicker/dist/react-datepicker.css';
import 'flatpickr/dist/themes/material_blue.css';
import Flatpickr from 'react-flatpickr';

import moment from 'moment';

import BarChart from '../../AllCharts/apex/barchart';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import { DateRangePicker } from 'rsuite';
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  CardTitle,
  CardHeader,
  Input,
  FormGroup,
  InputGroup,
} from 'reactstrap';

import CountUp from 'react-countup';

const fmtAmount = (num) =>
  Number(num || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const OrderSummaryCard = ({ flag, title, currency, data, netTotalKeys }) => {
  const open = Number(data?.total_open || 0);
  const posted = Number(data?.total_posted || 0);
  const notLs = Number(data?.total_not_in_ls || 0);
  const notLsB2b = Number(data?.total_not_in_ls_b2b || 0);
  const notLsNormal = Number(data?.total_not_in_ls_normal || 0);
  const pending = Number(data?.total_pending_payment || 0);
  const cancelled = Number(data?.total_canceled || 0);
  const netTotal = netTotalKeys.reduce(
    (sum, key) => sum + Number(data?.[key] || 0),
    0
  );
  const appOrders = Number(data?.total_app_orders || 0);
  const webOrders = Number(data?.total_web_orders || 0);
  const appAvg = Number(data?.total_app_average_order_value || 0);
  const webAvg = Number(data?.total_web_average_order_value || 0);
  const totalChannelOrders = appOrders + webOrders;
  const appPct =
    totalChannelOrders > 0
      ? Math.round((appOrders / totalChannelOrders) * 100)
      : 0;
  const webPct = totalChannelOrders > 0 ? 100 - appPct : 0;

  return (
    <Col xl={3} md={5}>
      <Card className="osCard h-100">
        <CardBody>
          <div className="osHeader">
            <div className="osHeaderLeft">
              <span className="osFlag">{flag}</span>
              <div className="osTitleWrap">
                <span className="osTitle">{title}</span>
                <span className="osSubtitle">Today&apos;s orders</span>
              </div>
            </div>
            <span className="osCurrencyBadge">{currency}</span>
          </div>

          <div className="osHero">
            <span className="osHeroLabel">Net Total</span>
            <span className="osHeroValue">
              <span className="osHeroCurrency">{currency}</span>{' '}
              {fmtAmount(netTotal)}
            </span>
          </div>

          <div className="osStatusList">
            <div className="osStatusRow">
              <span className="osLabel">Open</span>
              <span className="osValue">{fmtAmount(open)}</span>
            </div>
            <div className="osStatusRow">
              <span className="osLabel">Posted</span>
              <span className="osValue">{fmtAmount(posted)}</span>
            </div>
            <div className="osStatusRow osHighlight">
              <span className="osLabel">Not in LS</span>
              <span className="osValue">{fmtAmount(notLs)}</span>
            </div>
            <div className="osStatusRow osSubRow">
              <span className="osLabel">B2B + Normal</span>
              <span className="osValue">
                {fmtAmount(notLsB2b)} + {fmtAmount(notLsNormal)}
              </span>
            </div>
            <div className="osStatusRow">
              <span className="osLabel">Pending Payment</span>
              <span className="osValue">{fmtAmount(pending)}</span>
            </div>
            <div className="osStatusRow">
              <span className="osLabel">Cancelled</span>
              <span className="osValue">{fmtAmount(cancelled)}</span>
            </div>
          </div>

          <div className="osDivider" />

          <div className="osSectionLabel">Order Channel</div>
          <div className="osChannelBar">
            <div
              className="osChannelBarApp"
              style={{ width: `${appPct}%` }}
            />
            <div
              className="osChannelBarWeb"
              style={{ width: `${webPct}%` }}
            />
          </div>
          <div className="osChannelLegend">
            <span>
              <span className="osDot osDotApp" /> App {appPct}%
            </span>
            <span>
              <span className="osDot osDotWeb" /> Web {webPct}%
            </span>
          </div>

          <div className="osChannelGrid">
            <div className="osChannelTile">
              <div className="osChannelTileHead">
                <span className="osDot osDotApp" /> App
              </div>
              <div>
                <span className="osChannelTileCount">{appOrders}</span>
                <span className="osChannelTileCountLabel">orders</span>
              </div>
              <div className="osChannelTileAvg">
                Avg {currency} {fmtAmount(appAvg)}
              </div>
            </div>
            <div className="osChannelTile">
              <div className="osChannelTileHead">
                <span className="osDot osDotWeb" /> Web
              </div>
              <div>
                <span className="osChannelTileCount">{webOrders}</span>
                <span className="osChannelTileCountLabel">orders</span>
              </div>
              <div className="osChannelTileAvg">
                Avg {currency} {fmtAmount(webAvg)}
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

const OrderDashboard = () => {
  const [windowSize, setWindowSize] = useState(getWindowSize());
  const dispatch = useDispatch();
  const [startDate, setStartDate] = useState(
    new moment(new Date()).format('YYYY-MM-DD')
  );
  const { afterToday, combine, allowedMaxDays } = DateRangePicker;
  const [endDate, setEndDate] = useState(
    new moment(new Date()).format('YYYY-MM-DD')
  );
  const [active, setActiveValue] = useState('all');

  const [isLoading, setIsLoading] = useState(true);
  const [isChartLoading, setIsChartLoading] = useState(false);
  const [isLoadingLanguage, setIsLoadingLanguage] = useState(true);
  // const [isSummeryLoading, setIsSummeryLoading] = useState(true);
  const [customMonthRange, setCustomMonthRange] = useState([null, null]);
  const [customMonthApiTriggered, setCustomMonthApiTriggered] = useState(false);

  const [startDateGraph, setStartDateGraph] = useState(
    new moment(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)).format(
      'YYYY-MM-DD'
    )
  );
  const [endDateGraph, setEndDateGraph] = useState(
    new moment(new Date()).format('YYYY-MM-DD')
  );
  const [summaryType, setSummaryType] = useState('lastyear');
  const { StatusCount = [], isStatusLoading } = useSelector(
    (state) => state.dashboard
  );
  const Total = StatusCount?.data;

  const { countStatus = [], iscountStatusLoading } = useSelector(
    (state) => state.order
  );

  const { dashboardGraph = [], isGraphLoading } = useSelector(
    (state) => state.dashboard
  );

  const { summreryData = [], isSummeryLoading } = useSelector(
    (state) => state.dashboard
  );

  const growthData = summreryData?.data?.growthList;
  const advData = summreryData?.data?.advDataList;

  let isMobileView = 0;
  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);
  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }

  if (windowSize.innerWidth <= 1279 && isMobileView === 0) {
    isMobileView++;
  }

  let cntry = localStorage.getItem('WEBSITE_COUNTRY');

  if (cntry !== 'all' && cntry !== null) {
    cntry = cntry?.toUpperCase();
  }
  useEffect(() => {
    setIsLoading(false);
    fetchStatausCount({
      params: {
        date_from: startDate,
        date_to: endDate === undefined || endDate === '' ? startDate : endDate,
        country: cntry,
      },
      dispatch,
    });
  }, [startDate, endDate, cntry, dispatch]);
  useEffect(() => {
    setIsLoadingLanguage(false);
    fetchDashboardSummerydata({
      params: {
        date_from: startDate,
        date_to: endDate === undefined || endDate === '' ? startDate : endDate,
        country: cntry,
        language: active,
      },
      dispatch,
    });
  }, [active, startDate, endDate, cntry, dispatch]);

  useEffect(() => {
    if (summaryType === 'custommonth') {
      if (
        customMonthApiTriggered &&
        customMonthRange &&
        customMonthRange[0] instanceof Date &&
        !isNaN(customMonthRange[0]) &&
        customMonthRange[1] instanceof Date &&
        !isNaN(customMonthRange[1])
      ) {
        setIsChartLoading(true);
        allOrderStatusCount({
          params: {
            type: summaryType,
            country: cntry,
            date_from: moment(customMonthRange[0]).format('YYYY-MM-DD'),
            date_to: moment(customMonthRange[1]).format('YYYY-MM-DD'),
          },
          dispatch,
        });
      }
    } else if (summaryType === 'currentyearlastmonth') {
      // Pass only type and country, no date_from/date_to
      setIsChartLoading(true);
      allOrderStatusCount({
        params: {
          type: summaryType,
          country: cntry,
        },
        dispatch,
      });
    } else {
      setIsChartLoading(true);
      allOrderStatusCount({
        params: {
          type: summaryType,
          country: cntry,
        },
        dispatch,
      });
    }
    setIsChartLoading(false);
  }, [summaryType, cntry, customMonthApiTriggered, customMonthRange, dispatch]);

  const TotalCount = countStatus?.data;

  let statsDate = '';
  let endsDate = '';
  useEffect(() => {
    localStorage.setItem('startsDate', startDate);
    localStorage.setItem('endsDate', endDate);
  }, []);
  statsDate = localStorage.getItem('startsDate');
  endsDate = localStorage.getItem('endsDate');
  useEffect(() => {
    setIsLoading(false);
    let eDate = new moment(endDateGraph).format('YYYY-MM-DD');
    let sDate = new moment(startDateGraph).format('YYYY-MM-DD');
    if (
      startDateGraph === '' ||
      startDateGraph === undefined ||
      endDateGraph === '' ||
      endDateGraph === undefined
    ) {
      sDate = new moment(new Date() - 7).format('YYYY-MM-DD');
      eDate = new moment(new Date()).format('YYYY-MM-DD');
    }

    fetchDashboardGraphdata({
      params: {
        date_from: sDate === '' ? statsDate : sDate,
        date_to: eDate === '' ? endsDate : eDate,
        country: cntry,
      },
      dispatch,
    });
  }, [endDateGraph, startDateGraph, cntry, dispatch, statsDate, endsDate]);

  const splineGraph = dashboardGraph?.results;

  let contVal = cntry || '';

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Dashboard | DH OMS - Admin & Dashboard Template</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}

          <Row>
            <Col xl={6}>
              <DashBreadcrumb title="Dashboard" breadcrumbItem="Dashboard" />
            </Col>
            <Col xl={6} className="textAlignRight language">
              <div className="selectDashBoardOption">
                <select
                  className="form-control form-select"
                  name="is_active"
                  value={active}
                  onChange={(e) => {
                    setActiveValue(e?.target?.value);
                  }}
                >
                  <option value="all">All</option>
                  <option value="en">English</option>
                  <option value="ar">Arabic</option>
                </select>
              </div>

              <div className="DashbordFliter">
                {isMobileView !== 0 ? (
                  <>
                    <DateRangePicker
                      placement="auto"
                      placeholder="Select Date Range"
                      onClean={() => {
                        setStartDate(
                          new moment(new Date()).format('YYYY-MM-DD')
                        );
                        setEndDate(new moment(new Date()).format('YYYY-MM-DD'));
                      }}
                      showOneCalendar
                      onChange={(selectedDates, instance) => {
                        const dateStr = selectedDates?.[0];
                        const first_Date = new Date(dateStr)?.toString();
                        const firstD = moment(new Date(first_Date))?.format(
                          'YYYY/MM/DD'
                        );
                        const firstDateReplace = firstD?.replaceAll('/', '-');
                        const dateStr1 = selectedDates?.[1];
                        const second_Date = new Date(dateStr1)?.toString();
                        const secondD = moment(new Date(second_Date))?.format(
                          'YYYY/MM/DD'
                        );
                        const secondDateReplace = secondD?.replaceAll('/', '-');
                        setStartDate(firstDateReplace);
                        setEndDate(secondDateReplace);
                      }}
                    />
                  </>
                ) : (
                  <>
                    <DateRangePicker
                      placement="leftStart"
                      placeholder="Select Date Range"
                      onClean={() => {
                        setStartDate(
                          new moment(new Date()).format('YYYY-MM-DD')
                        );
                        setEndDate(new moment(new Date()).format('YYYY-MM-DD'));
                      }}
                      // disabledDate={combine(allowedMaxDays(30), afterToday())}
                      onChange={(selectedDates, instance) => {
                        const dateStr = selectedDates?.[0];
                        const first_Date = new Date(dateStr)?.toString();
                        const firstD = moment(new Date(first_Date))?.format(
                          'YYYY/MM/DD'
                        );
                        const firstDateReplace = firstD?.replaceAll('/', '-');
                        const dateStr1 = selectedDates?.[1];
                        const second_Date = new Date(dateStr1)?.toString();
                        const secondD = moment(new Date(second_Date))?.format(
                          'YYYY/MM/DD'
                        );
                        const secondDateReplace = secondD?.replaceAll('/', '-');
                        setStartDate(firstDateReplace);
                        setEndDate(secondDateReplace);
                      }}
                    />{' '}
                  </>
                )}
              </div>
            </Col>
          </Row>
          {cntry === 'all' || isLoading || isLoadingLanguage ? (
            <>
              <Row
                className="row-fluid-scroll flex-nowrap mb-4"
                style={{ overflowX: 'scroll' }}
              >
                <OrderSummaryCard
                  flag="🇦🇪"
                  title="UAE"
                  currency="AED"
                  data={Total?.AE}
                  netTotalKeys={[
                    'total_open',
                    'total_posted',
                    'total_not_in_ls',
                  ]}
                />
                <OrderSummaryCard
                  flag="🇴🇲"
                  title="Oman"
                  currency="OMR"
                  data={Total?.OM}
                  netTotalKeys={[
                    'total_open',
                    'total_posted',
                    'total_not_in_ls',
                  ]}
                />
                <OrderSummaryCard
                  flag="🇧🇭"
                  title="Bahrain"
                  currency="BHD"
                  data={Total?.BH}
                  netTotalKeys={['total_posted', 'total_not_in_ls']}
                />
                <OrderSummaryCard
                  flag="🇶🇦"
                  title="Qatar"
                  currency="QAR"
                  data={Total?.QA}
                  netTotalKeys={['total_posted', 'total_not_in_ls']}
                />
              </Row>
            </>
          ) : (
            <>
              <Row>
                {isSummeryLoading ? (
                  <>
                    <CardBody>
                      <Skeleton count={5} />
                    </CardBody>
                  </>
                ) : null}

                {growthData?.map((items) => {
                  return (
                    <Col md={12} lg={12} xl={6}>
                      <Card>
                        <CardHeader className="d-sm-flex align-items-center justify-content-between bg-soft-light">
                          <CardTitle>
                            <Row className="align-items-center">
                              <Col>
                                {items?.type === 'app'
                                  ? 'Mobile App'
                                  : items?.type === 'kiosk'
                                    ? 'Kiosk'
                                    : items?.type === 'hexakiosk'
                                      ? 'Hexa Kiosk'
                                      : 'Website'}
                              </Col>
                              <Col className="d-md-none">
                                <span className="display-5 text-success d-flex justify-content-end">
                                  <i className="bx bx-trending-up"></i>
                                </span>
                              </Col>
                            </Row>
                          </CardTitle>
                        </CardHeader>
                        <CardBody className="trendingBody">
                          <div className="trendingContain">
                            <Row className="align-items-center px-0 mt-3">
                              <Col sm={2} className="d-none d-md-block">
                                <span
                                  className={`display-5 ${items?.growthRate > 0
                                    ? 'text-success'
                                    : 'text-danger'
                                    } d-flex justify-content-center`}
                                >
                                  <i
                                    className={`bx ${items?.growthRate > 0
                                      ? 'bx-trending-up'
                                      : 'bx-trending-down'
                                      }`}
                                  ></i>
                                </span>
                              </Col>
                              <Col>
                                <p className="d-flex align-items-center justify-content-start gap-2 mb-0 trendingTitle">
                                  <span className="title">Revenue</span>
                                  <strong className="fw-medium">
                                    {items?.totalCYSale || 0}
                                  </strong>
                                </p>
                                <p className="d-flex align-items-center justify-content-start gap-2 trending m-0">
                                  <span
                                    className={`${items?.growthRate > 0
                                      ? 'bg-soft-success text-success'
                                      : 'bg-soft-danger text-danger'
                                      } p-1 fw-medium text-center`}
                                  >
                                    <i
                                      className={`mdi ${items?.growthRate > 0
                                        ? 'mdi-arrow-up-bold'
                                        : 'mdi-arrow-down-bold'
                                        }`}
                                    ></i>{' '}
                                    {items?.growthRate || 0}%
                                    <span>
                                      {' '}
                                      {items?.growthRate > 0
                                        ? 'Increase'
                                        : 'Decrease'}
                                    </span>
                                  </span>
                                  <small>
                                    compare last year ({items?.totalPYSale || 0}
                                    )
                                  </small>
                                </p>
                              </Col>
                              <Col>
                                <p className="d-flex align-items-center justify-content-start gap-2 mb-0 trendingTitle">
                                  <span className="title">No.of Orders</span>
                                  <strong className="fw-medium ">
                                    {items?.totalCYOrders || 0}
                                  </strong>
                                </p>
                              </Col>
                            </Row>
                            <hr className="horizontal" />
                            <Row className="align-items-center px-0 m-0">
                              {items?.deviceData?.map((itemData, index) => {
                                return (
                                  <>
                                    <Col>
                                      <Row className="align-items-center">
                                        <Col sm={12}>
                                          <Row className="align-items-center">
                                            <Col sm={2}>
                                              <span
                                                className={`d-flex ${itemData?.type === 'ios'
                                                  ? 'appleIcon'
                                                  : itemData?.type ===
                                                    'android'
                                                    ? 'androidIcon'
                                                    : itemData?.type ===
                                                      'mobile'
                                                      ? 'cellphoneIcon'
                                                      : 'desktopIcon'
                                                  }`}
                                              >
                                                <i
                                                  className={`mdi ${itemData?.type === 'ios'
                                                    ? 'mdi-apple'
                                                    : itemData?.type ===
                                                      'android'
                                                      ? 'mdi-android'
                                                      : itemData?.type ===
                                                        'mobile'
                                                        ? 'mdi-cellphone'
                                                        : 'mdi-desktop-mac'
                                                    }`}
                                                ></i>
                                                <span className="d-md-none deviceType">
                                                  {itemData?.type.toUpperCase()}
                                                </span>
                                              </span>
                                            </Col>
                                            <Col>
                                              <p className="mb-1 trendingDeviceTitleLabel">
                                                <span className="title">
                                                  Revenue
                                                </span>
                                              </p>
                                              <h6 className="d-flex align-items-center justify-content-start gap-1  mb-0 trendingDeviceTitle">
                                                <strong className="fw-medium">
                                                  {itemData?.totalCYSale || 0}
                                                </strong>
                                                <small className="text-success">
                                                  No.of Orders :{' '}
                                                  {itemData?.totalCYOrders || 0}
                                                </small>
                                              </h6>
                                            </Col>
                                            <Col
                                              sm={2}
                                              className="d-none d-md-block "
                                            >
                                              <span className="text-success d-flex justify-content-center trendingIcon">
                                                <i className="bx bx-trending-up"></i>
                                              </span>
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col>
                                              <p className="d-flex align-items-center justify-content-start gap-2 trendingDevice my-1">
                                                <span
                                                  className={`bg-${itemData?.growthRate > 0
                                                    ? 'soft-success text-success'
                                                    : 'soft-danger text-danger'
                                                    } p-1 fw-medium text-center`}
                                                >
                                                  <i
                                                    className={`mdi mdi-arrow-${itemData?.growthRate > 0
                                                      ? 'up'
                                                      : 'down'
                                                      }-bold`}
                                                  ></i>{' '}
                                                  {itemData?.growthRate || 0}%
                                                  <span> Increase</span>
                                                </span>
                                                <small>
                                                  compare last year (
                                                  {itemData?.totalPYSale || 0})
                                                </small>
                                              </p>
                                            </Col>
                                          </Row>
                                        </Col>
                                      </Row>
                                    </Col>
                                    {index === 0 ? (
                                      <hr className="vertical" />
                                    ) : null}
                                  </>
                                );
                              })}
                            </Row>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  );
                })}
              </Row>

              <Row>
                <Col>
                  <Card>
                    <CardHeader className="d-sm-flex align-items-center justify-content-between bg-soft-light">
                      <CardTitle>
                        <Row className="align-items-center">
                          <Col>
                            Source Analytics -
                            <span>
                              {startDate} - {endDate}
                            </span>
                          </Col>
                          <Col className="d-md-none">
                            <span className="display-5 text-success d-flex justify-content-end">
                              <i className="bx bx-trending-up"></i>
                            </span>
                          </Col>
                        </Row>
                      </CardTitle>
                    </CardHeader>
                    {isSummeryLoading ? (
                      <>
                        <CardBody>
                          <Skeleton count={5} />
                        </CardBody>
                      </>
                    ) : null}
                    <CardBody className="trendingBody">
                      <div className="trendingContain">
                        {/* <Row>
                          <Col md={12} lg={12} xl={6}>
                            <Row className="align-items-center px-0 mt-3">
                              <Col sm={2} className="d-none d-md-block">
                                <span className="display-5 text-success d-flex justify-content-center">
                                  <i className="bx bx-trending-up"></i>
                                </span>
                              </Col>
                              <Col>
                                <p className="d-flex align-items-center justify-content-start gap-2 mb-0 trendingTitle">
                                  <span className="title">Revenue</span>
                                  <strong className="fw-medium">24K</strong>
                                </p>
                                <p className="d-flex align-items-center justify-content-start gap-2 trending m-0">
                                  <span className="bg-success p-1 fw-medium text-center">
                                    <i className="mdi mdi-arrow-up-bold"></i> 20%
                                    <span>Increase</span>
                                  </span>
                                  <small>From last month (250K)</small>
                                </p>
                              </Col>
                              <Col>
                                <p className="d-flex align-items-center justify-content-start gap-2 mb-0 trendingTitle">
                                  <span className="title">No.of Orders</span>
                                  <strong className="fw-medium ">240</strong>
                                </p>

                                <p className="d-flex align-items-center justify-content-start gap-2 trending m-0">
                                  <span className="bg-success p-1 fw-medium text-center">
                                    <i className="mdi mdi-arrow-up-bold"></i> 20%
                                    <span>Increase</span>
                                  </span>
                                  <small>From last month (250)</small>
                                </p>
                              </Col>
                            </Row>
                          </Col>
                        </Row> */}

                        {/* <hr className="horizontal" /> */}
                        <Row className="row-cols-2 row-cols-md-6 row-cols-xl-6 m-0">
                          {advData?.map((advItem) => {
                            return (
                              <Col>
                                <Row className="align-items-center">
                                  <Col sm={12} className="adVsOrganic">
                                    <Row className="align-items-center">
                                      <Col>
                                        <p className="mb-1 trendingDeviceTitleLabel">
                                          <span className="title">
                                            {advItem?.type}
                                          </span>
                                        </p>
                                        <h6 className="d-flex align-items-center justify-content-start gap-1  mb-0 trendingDeviceTitle">
                                          <strong className="fw-medium">
                                            {advItem?.total}
                                          </strong>
                                        </h6>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </Col>
                            );
                          })}
                        </Row>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </>
          )}
          <Row>
            {cntry === 'all' ? (
              <>
                {' '}
                <Col xl={12}>
                  <Card>
                    <CardHeader className="d-sm-flex align-items-center justify-content-between">
                      <CardTitle>Orders Summary</CardTitle>
                      <Col xl={3}>
                        <div className="InputBg">
                          <i className="bx bx-calendar"></i>
                          <FormGroup>
                            <InputGroup>
                              <Flatpickr
                                className="form-control d-block"
                                defaultValue={`${startDateGraph} to ${endDateGraph}`}
                                options={{
                                  mode: 'range',
                                  dateFormat: 'Y-m-d',
                                }}
                                onChange={(
                                  selectedDates,
                                  dateStr,
                                  instance
                                ) => {
                                  const date_split = dateStr.split('to');
                                  const firstDate = date_split[0];
                                  setStartDateGraph(firstDate);
                                  const secondDate = date_split[1];
                                  setEndDateGraph(secondDate);
                                }}
                              />
                            </InputGroup>
                          </FormGroup>
                        </div>
                      </Col>
                    </CardHeader>
                    {dashboardGraph?.code === '100' ? (
                      <>
                        <CardBody>
                          <div dir="ltr">
                            <Spinearea splineGraph={splineGraph} />
                          </div>
                        </CardBody>
                      </>
                    ) : (
                      <>
                        <CardBody>
                          <Skeleton count={5} />
                        </CardBody>
                      </>
                    )}
                  </Card>
                </Col>
                <Col xl={6}>
                  <Card>
                    <CardHeader>
                      <CardTitle>Revenue Summary</CardTitle>
                    </CardHeader>
                    {dashboardGraph?.code === '100' ? (
                      <>
                        <CardBody>
                          <div dir="ltr">
                            <RevenueSplineArea splineGraph={splineGraph} />
                          </div>
                        </CardBody>
                      </>
                    ) : (
                      <>
                        <CardBody>
                          <Skeleton count={5} />
                        </CardBody>
                      </>
                    )}
                  </Card>
                </Col>
                <Col xl={6}>
                  <Card>
                    <CardHeader>
                      <CardTitle>Average Order Value</CardTitle>
                    </CardHeader>
                    {dashboardGraph?.code === '100' ? (
                      <>
                        <CardBody>
                          <div dir="ltr">
                            <AovSplineArea splineGraph={splineGraph} />
                          </div>
                        </CardBody>
                      </>
                    ) : (
                      <>
                        <CardBody>
                          <Skeleton count={5} />
                        </CardBody>
                      </>
                    )}
                  </Card>
                </Col>
              </>
            ) : (
              <>
                <Col>
                  <Card className="testChart">
                    <CardHeader className="d-sm-flex align-items-center justify-content-between">
                      <CardTitle>{contVal} Sales Analysis</CardTitle>
                      <Col className="d-flex justify-content-end align-items-center gap-2">
                        {summaryType === 'custommonth' && (
                          <DateRangePicker
                            placement="auto"
                            placeholder="Select Date Range"
                            value={customMonthRange}
                            onChange={(selectedDates) => {
                              setCustomMonthRange(selectedDates);
                              setCustomMonthApiTriggered(true);
                            }}
                          />
                        )}
                        <FormGroup
                          onChange={(e) => {
                            setSummaryType(e.target.value);
                            if (e.target.value === 'custommonth') {
                              setCustomMonthApiTriggered(false); // reset trigger
                            } else {
                              setCustomMonthRange([null, null]); // reset range when leaving custommonth
                              setCustomMonthApiTriggered(false);
                            }
                          }}
                        >
                          <Input type="select" name="type">
                            <option value="lastyear">
                              Select Summary Type
                            </option>
                            <option value="lastyear">
                              Compare with Last Year
                            </option>
                            <option value="lastmonth">
                              Day to day comparison (Last year current month)
                            </option>
                            <option value="currentyearlastmonth">
                              Day to day comparison (This year last month)
                            </option>
                            <option value="lastweek">
                              Current week comparison (with last year)
                            </option>
                            <option value="currentyearlastweek">
                              Current week comparison (with last week this year)
                            </option>
                            <option value="currentyearlastMonthlastweek">
                              Current week comparison (with last month same week this year)
                            </option>
                            <option value="custommonth">
                              Compare with Custom Date Range
                            </option>
                          </Input>
                        </FormGroup>
                      </Col>
                    </CardHeader>

                    {countStatus?.code === 100 ? (
                      <>
                        {' '}
                        <CardBody>
                          <BarChart
                            TotalCount={TotalCount}
                            summaryType={summaryType}
                            loading={iscountStatusLoading}
                            startDate={
                              summaryType === 'custommonth' &&
                                customMonthRange[0]
                                ? moment(customMonthRange[0]).format(
                                  'DD-MM-YYYY'
                                )
                                : undefined
                            }
                            endDate={
                              summaryType === 'custommonth' &&
                                customMonthRange[1]
                                ? moment(customMonthRange[1]).format(
                                  'DD-MM-YYYY'
                                )
                                : undefined
                            }
                          />
                        </CardBody>
                      </>
                    ) : (
                      <>
                        {' '}
                        <CardBody>
                          <Skeleton count={5} />
                        </CardBody>
                      </>
                    )}
                  </Card>
                </Col>
              </>
            )}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default OrderDashboard;
